import { MOTES } from '../../config/constants.js';

/**
 * A dropped scrap of XP (BULLET-HEAVEN.md §H1). Mirrors HealthPod: a dumb
 * position with an `active` flag, driven entirely by PickupSystem — it has no
 * update() of its own, because everything that happens to a mote (magnet pull,
 * vacuum, collection) is a function of where the player is, which the mote
 * doesn't know.
 *
 * `xp` is the whole payload the source banked: the flat kill bonus plus every
 * point of damage-XP earned whittling that minion down. Total XP per minion is
 * therefore identical to what it was when kills paid out directly — this moves
 * the reward, it does not resize it.
 */
export class XpMote {
  constructor({ x, y, xp, tier = 'small' }) {
    this.x = x;
    this.y = y;
    this.xp = xp;
    this.tier = tier;
    const spec = MOTES.tiers[tier] ?? MOTES.tiers.small;
    this.radius = MOTES.radius * spec.scale;
    this.color = spec.color;
    this.active = true;
    // Seconds on the floor. Past MOTES.lifetime the mote stops waiting and
    // streams to the player under its own power (see PickupSystem) — a mote is
    // never lost, only late.
    this.age = 0;
    this.vacuuming = false;
    // Fixed per mote so a field of them drifts out of phase rather than
    // pulsing in unison, which reads as a rendering bug rather than as life.
    this.bobPhase = Math.random() * Math.PI * 2;
  }
}
